export const baseURL = process.env.REACT_APP_BASEURL_BACKOFFICE;
export const baseURLV1 = process.env.REACT_APP_BASEURL_BACKOFFICE + '/api/v1';
export const imageURL = process.env.REACT_APP_IMAGEURL + '/uploads';
export const campaigns_id_privilage = process.env.REACT_APP_CAMPAIGN;
export const privilegeURL = process.env.REACT_APP_BASEURL_BACKOFFICE+ '/api/v1/privilege';
export const privilegeURLV2 = process.env.REACT_APP_PRIVILAGE_URL+ '/api/v2';
export const privilegeURL2 = process.env.REACT_APP_PRIVILAGE_URL + '/api/v1';
export const imageURL2 = process.env.REACT_APP_PRIVILAGE_URL;
export const KEY = process.env.REACT_APP_KEY;
